module.exports = __webpack_public_path__ + "img/1737565940256.b9a9e6dd.jpg";